import { render, staticRenderFns } from "./GroupsEdit.vue?vue&type=template&id=6ee57182&scoped=true&"
import script from "./GroupsEdit.vue?vue&type=script&lang=js&"
export * from "./GroupsEdit.vue?vue&type=script&lang=js&"
import style0 from "./GroupsEdit.vue?vue&type=style&index=0&id=6ee57182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee57182",
  null
  
)

export default component.exports